/**
 * @author  Agence Dn'D <contact@dnd.fr>
 * @license https://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * @link    https://www.dnd.fr/
 */

(() => {
    if (window.strapSizesInitialized) return;
    window.strapSizesInitialized = true;

    class StrapSizes {
        constructor(container) {
            this.container = container;
            const sectionId = container.dataset.sectionId;
            const formId    = container.dataset.formId;

            this.sizeOptionsList   = document.getElementById(`size-options-list-${sectionId}`);
            this.sizeOptionsHeader = document.getElementById(`size-options-header-${sectionId}`);
            this.sizeOptionsLabel  = document.getElementById(`size-options-label-${sectionId}`);
            this.dropdownButton    = this.sizeOptionsHeader.querySelector(
                `button[aria-controls="size-options-list-${sectionId}"]`
            );
            this.sizeItems = this.sizeOptionsList.querySelectorAll('.size-item');

            this.inputSizeProperty = document.getElementById(`selected-size-${sectionId}`);
            this.addToCartButton   = document.getElementById(formId)
                ?.querySelector('button[name="add"]');
            this.errorMessage      = document.getElementById(`size-message-error-${sectionId}`);

            if (!this.addToCartButton || !this.inputSizeProperty || !this.errorMessage) {
                return;
            }

            this.init();
        }

        init() {
            this.addToCartButton.addEventListener('click', (e) => this.checkSizeValue(e));
            this.sizeOptionsList.addEventListener('click', (e) => this.getSizeValue(e));
            this.sizeOptionsHeader.addEventListener('click', () => this.toggleSizesList());
            this.addToCartButton.disabled = true;

            this.sizeItems.forEach((item) => {
                item.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.selectSize(item);
                    }
                });
            });
        }

        checkSizeValue = (e) => {
            if (!this.inputSizeProperty.value) {
                e.preventDefault();
                this.errorMessage.classList.add('show');
            }
        };

        getSizeValue = (event) => {
            const item = event.target.closest('.size-item');
            if (!item) return;
            this.selectSize(item);
        };

        selectSize = (item) => {
            this.inputSizeProperty.setAttribute('value', item.getAttribute('data-size'));
            this.sizeOptionsList.classList.remove('show');
            this.sizeOptionsLabel.innerHTML = item.getAttribute('data-size');

            this.sizeOptionsList.hidden = true;
            this.dropdownButton.setAttribute('aria-expanded', 'false');
            this.addToCartButton.disabled = false;

            this.sizeItems.forEach((el) => el.classList.remove('selected'));
            item.classList.add('selected');

            if (this.errorMessage.classList.contains('show')) {
                this.errorMessage.classList.remove('show');
            }
        };

        toggleSizesList = () => {
            const isOpen = this.sizeOptionsList.classList.contains('show');
            this.sizeOptionsList.classList.toggle('show');
            this.sizeOptionsList.hidden = isOpen;
            this.dropdownButton.setAttribute('aria-expanded', String(!isOpen));
        };
    }

    document.querySelectorAll('.size-options-container[data-section-id]').forEach((container) => {
        new StrapSizes(container);
    });
})();